import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Kilimall/seller/Home.vue'
import Layout from '@/components/layout/index.vue'
import { menuRouter } from '@/utils/base'
import { getIframePath } from '@/utils/cookies'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import i18n from "@/locales/index";
import { whiteList, whiteNames } from '@/config/whitelist'
import type { Action } from 'element-plus'
import HelpCenterLayout from '@/components/layout/HelpCenterLayout.vue'
import store  from '@/store'

const { t } = i18n.global;
const constantFiles = require.context('./constant', true, /\.ts$/)

let constantModules: Array<RouteRecordRaw> = []
constantFiles.keys().forEach((key: string) => {
  if (key === './index.ts') return
  constantModules = constantModules.concat(constantFiles(key).default)
})

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/dom',
    component: Layout,
    children: [
      {
        path: '/dom',
        component: () => import('@/views/dom.vue'),
        name: 'dom',
        meta: {
          title_en: 'dom',
          title: 'dom'
        },
      }
    ]
  },
  {
    path: '/iframe',
    component: Layout,
    children: [
      {
        path: '/iframe',
        component: () => import('@/views/Kilimall/seller/Iframe.vue'),
        name: 'iframe',
        meta: {
          title_en: 'test',
          title: 'test'
        },
      }
    ]
  },
  // 帮助中心
  {
    path: '/help-center',
    component: HelpCenterLayout,
    redirect: '/help-center',
    meta: { title_en: 'Help Center', title: '帮助中心' },
    children: [
      {
        path: '/help-center/:mid/:id?',
        component: () => import('@/views/help-center/Home.vue'),
        name: 'HelpCenter'
      },
      {
        path: '/help-center/detail/:aid',
        component: () => import('@/views/help-center/HelpDetail.vue'),
        name: 'HelpDetail'
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    name: 'layout',
    redirect: '/home',
    meta: {
      title_en: 'Home Page',
      title: '首页'
    },
    children: [
      {
        path: '/KiliMall/goodsEditUpload',
        name: 'Edit Product',
        meta: {
          title_en: 'Edit Product',
          title: '编辑商品'
        },
        component: () => import('@/views/Kilimall/seller/goodsEditUpload.vue'),
      },
      {
        path: '/KiliMall/goodsBndgift', name: '绑定礼品',
        meta: {
          title_en: 'Bind Gift',
          title: '绑定礼品'
        },
        component: () => import('@/views/Kilimall/seller/goodsBndgift.vue')
      },
      {
        path: '/ActiveBackstage/signUp',
        name: '报名记录',
        meta: {
          title_en: 'Event Apply Records',
          title: '报名记录'
        },
        component: () => import('@/views/Kilimall/seller/ActiveBackstage/signUp.vue'),
      },
      {
        path: '/ActiveBackstage/process',
        name: '立即报名',
        meta: {
          title_en: 'Apply Now',
          title: '立即报名'
        },
        component: () => import('@/views/Kilimall/seller/ActiveBackstage/process.vue'),
      },
      {
        path: '/KiliMall/FlashSales/fillInfoGoods',
        name: '编辑活动商品信息',
        meta: {
          title_en: 'Edit flash sale product information',
          title: '编辑活动商品信息'
        },
        component: () => import('@/views/Kilimall/seller/FlashSales/fillInfoGoods.vue'),
      },
      {
        path: '/KiliMall/PaidPromotion/PromotionCommodities',
        name: '新增推广计划',
        meta: {
          title_en: ' Create Campaign',
          title: '新增推广计划'
        },
        component: () => import('@/views/Kilimall/seller/PaidPromotion/PromotionCommodities.vue'),
      },
      {
        path: '/KiliMall/brandCheck',
        name: '品牌审核',
        meta: {
          title_en: 'Brand Application',
          title: '品牌审核'
        },
        component: () => import('@/views/Kilimall/seller/brandCheck.vue')
      },
      {
        path: '/KiliMall/afterSale/afterList',
        name: '商家售后列表',
        meta: {
          title_en: 'AfterSale Order List',
          title: '商家售后列表'
        },
        component: () => import('@/views/Kilimall/manage/afterSale/afterList.vue')
      },
      {
        path: '/KiliMall/afterSale/replacementAudit',
        name: '商家售后详情',
        meta: {
          title_en: 'AfterSale Order Details',
          title: '商家售后详情'
        },
        component: () => import('@/views/Kilimall/manage/afterSale/replacementAudit.vue')
      },
      {
        path: '/lite/admin/restockDetail/:id', name: '备货邀请详情',
        meta: {
          title_en: 'View Restock Invitation',
          title: '备货邀请详情'
        }, component: () => import('@/views/Kilimall/manage/restockPlanning/restockDetail.vue')
      },
      {
        path: '/lite/admin/applyRestock/:id', name: 'Apply Restock',
        meta: {
          title_en: 'Apply Restock',
          title: '申请备货'
        }, component: () => import('@/views/Kilimall/manage/restockPlanning/applyRestock.vue')
      },
    ]
    // children:[
    //   {
    //     path: '/KiliMall/product', 
    //     name:'商品' ,
    //     meta:{
    //       title_en:'Product',
    //       title:'商品'
    //     },
    //     component: () => import('@/views/Kilimall/seller/product.vue'),     
    //     children:[
    //       {
    //         path: '/KiliMall/goodsList', 
    //         name:'管理商品' ,
    //         meta:{
    //           title_en:'All Products',
    //           title:'管理商品'
    //         },
    //         component: () => import('@/views/Kilimall/seller/goodsList.vue'),    
    //       },
    //       { path: '/KiliMall/drafts', name:'草稿箱' ,
    //       meta:{
    //         title_en:'Draft Box',
    //         title:'草稿箱'
    //       }, component: () => import('@/views/Kilimall/seller/drafts.vue')},

    //       { path: '/KiliMall/brandCheck',
    //       name:'品牌审核',
    //       meta:{
    //         title_en:'Brand Application',
    //         title:'品牌审核'
    //       }, 
    //        component: () => import('@/views/Kilimall/seller/brandCheck.vue')},
    //       { path: '/KiliMall/brandApply',name:'品牌申请',
    //       meta:{
    //         title_en:'Brand Application',
    //         title:'品牌申请'
    //       },
    //        component: () => import('@/views/Kilimall/seller/brandApply.vue')},
    //        {
    //         path: '/KiliMall/goodsBndgift', name: '绑定礼品',
    //         meta: {
    //           title_en:'Bind Gift',
    //           title:'绑定礼品'
    //         },
    //         component: () => import('@/views/Kilimall/seller/goodsBndgift.vue')
    //       },

    //     ]
    //   },
    //   { path: '/KiliMall/categoryVue',
    //   name:'编辑品类',
    //   meta: {
    //     title_en:'Edit Category',
    //     title:'编辑品类'
    //   },
    //  component: () => import('@/views/Kilimall/seller/categoryCheck.vue')},
    //   { path: '/KiliMall/goodsEditUpload', name:'编辑商品' ,
    //   meta:{
    //    title_en:'Edit Product',
    //    title:'编辑商品'
    //  }, component: () => import('@/views/Kilimall/seller/goodsEditUpload.vue') },

    //   {
    //     path: '/KiliMall/error', name: '开发中',
    //     meta: {
    //       title_en:'error',
    //       title:'开发中'
    //     },
    //     component: () => import('@/views/Kilimall/seller/error.vue')
    //   },
    // ]

  },
  { path: '/KiliMall/storeList', component: () => import('@/views/Kilimall/manage/storeList.vue') },
  { path: '/KiliMall/merchantReconciliation', component: () => import('@/views/Kilimall/manage/merchantReconciliation.vue') },
  {
    path: '/KiliMall/qualityScore', name: '质量分', meta: {
      title_en: 'qualityScore',
      title: '质量分'
    }, component: () => import('@/views/Kilimall/manage/qualityScore.vue')
  },
  { path: '/KiliMall/merchantList', name: '店铺列表', component: () => import('@/views/Kilimall/manage/merchantList.vue') },
  { path: '/KiliMall/billManage/exchangeRateList', name: '汇率列表', component: () => import('@/views/Kilimall/manage/billManage/exchangeRateList.vue') },
  { path: '/KiliMall/billManage/reconciliationList', name: '账户补扣', component: () => import('@/views/Kilimall/manage/billManage/reconciliationList.vue') },
  { path: '/KiliMall/billManage/accountReport', name: '平台账单明细', component: () => import('@/views/Kilimall/manage/billManage/accountReport.vue') },
  { path: '/KiliMall/billManage/billReport', name: '平台账单报表', component: () => import('@/views/Kilimall/manage/billManage/billReport.vue') },
  { path: '/KiliMall/billManage/settlementList', name: '平台未结算单', component: () => import('@/views/Kilimall/manage/billManage/settlementList.vue') },
  { path: '/KiliMall/billManage/settlementManage', name: '平台结算单', component: () => import('@/views/Kilimall/manage/billManage/settlementManage.vue') },
  { path: '/KiliMall/admin/afterSale/afterType', name: '售后类型', component: () => import('@/views/Kilimall/manage/afterSale/afterType.vue') },
  { path: '/KiliMall/admin/afterSale/afterQualityCheck', name: '售后质检', component: () => import('@/views/Kilimall/manage/afterSale/afterQualityCheck.vue') },
  { path: '/KiliMall/admin/afterSale/afterRule', name: '售后规则配置', component: () => import('@/views/Kilimall/manage/afterSale/afterRule.vue') },
  { path: '/KiliMall/afterSale/afterReturnList', name: '售后退回列表', component: () => import('@/views/Kilimall/manage/afterSale/afterReturnList.vue') },
  { path: '/KiliMall/admin/afterSale/afterDeliveryTime', name: '售后发货时效', component: () => import('@/views/Kilimall/manage/afterSale/afterDeliveryTime.vue') },
  { path: '/KiliMall/seo/pc_seo', name: 'PC电商SEO', component: () => import('@/views/Kilimall/manage/seo/pc_seo.vue') },
  { path: '/Seller/billManage/accountReport', name: '商家账单明细', component: () => import('@/views/Kilimall/seller/billManage/accountReport.vue') },
  { path: '/Seller/billManage/billReport', name: '商家账单报表', component: () => import('@/views/Kilimall/seller/billManage/billReport.vue') },
  {
    path: '/KiliMall/afterSale/platformAfterList',
    name: '平台售后列表',
    meta: {
      title_en: 'AfterSale Order List',
      title: '平台售后列表'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterList.vue')
  },
  {
    path: '/KiliMall/afterSale/replacementPlat',
    name: '平台售后详情',
    meta: {
      title_en: 'AfterSale Order Details',
      title: '平台售后详情'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/replacementAudit.vue')
  },
  {
    path: '/KiliMall/afterSale/platformAfterDetail',
    name: '平台新售后详情',
    meta: {
      title_en: 'AfterSale Order Details',
      title: '平台新售后详情'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterDetail.vue')
  },
  {
    path: '/lite/afterSale/platformAfterList',
    name: 'lite平台售后列表',
    meta: {
      title_en: 'AfterSale Order List',
      title: 'lite平台售后列表'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterList.vue')
  },
  {
    path: '/lite/afterSale/platformAfterDetail',
    name: 'lite平台售后详情',
    meta: {
      title_en: 'AfterSale Order Details',
      title: 'lite平台售后详情'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterDetail.vue')
  },
  {
    path: '/lite/afterSale/applyForUser',
    name: 'liteApplyForUser',
    meta: {
      title_en: 'Can Apply Aftersale Order List',
      title: 'lite代用户申请售后'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterApplyForUserList.vue')
  },
  {
    path: '/lite/afterSale/afterRefundList',
    name: 'liteAfterRefundList',
    meta: {
      title_en: 'Aftersale Refund Order List',
      title: 'lite售后退款列表'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterRefundList.vue')
  },
  {
    path: '/lite/admin/afterSale/afterReasonGroup',
    name: 'liteAfterReasonGroup',
    meta: {
      title_en: 'Aftersale Reason Group Management',
      title: 'lite售后原因组设置'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterSaleReasonGroup.vue')
  },
  {
    path: '/lite/admin/afterSale/afterReasonSet',
    name: 'liteAfterReasonSet',
    meta: {
      title_en: 'Aftersale Reason Management',
      title: 'lite售后原因设置'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterReasonSet.vue')
  },
  { path: '/lite/afterSale/refundDetail', name: 'liteRefundDetail', meta: { title_en: 'Refund Details', title: 'lite售后退回详情' }, component: () => import('@/views/Kilimall/manage/afterSale/afterReturnDetail.vue') },
  { path: '/lite/admin/afterSale/afterReasonBind', name: 'lite售后原因分组绑定', component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterReasonsBind.vue') },
  { path: '/lite/admin/afterSale/afterReasons', name: 'lite售后原因', component: () => import('@/views/Kilimall/manage/afterSale/afterSaleReasonTabs.vue') },
  { path: '/lite/afterSale/afterReturnList', name: 'lite售后退回列表', component: () => import('@/views/Kilimall/manage/afterSale/afterReturnList.vue') },
  { path: '/lite/admin/afterSale/afterType', name: 'lite售后类型', component: () => import('@/views/Kilimall/manage/afterSale/afterType.vue') },
  { path: '/lite/admin/afterSale/afterQualityCheck', name: 'lite售后质检', component: () => import('@/views/Kilimall/manage/afterSale/afterQualityCheck.vue') },
  { path: '/lite/admin/afterSale/afterRule', name: 'lite售后规则配置', component: () => import('@/views/Kilimall/manage/afterSale/afterRule.vue') },
  { path: '/lite/afterSale/afterReturnList', name: 'lite售后退回列表', component: () => import('@/views/Kilimall/manage/afterSale/afterReturnList.vue') },
  { path: '/lite/admin/afterSale/afterDeliveryTime', name: 'lite售后发货时效', component: () => import('@/views/Kilimall/manage/afterSale/afterDeliveryTime.vue') },
  {
    path: '/KiliMall/afterSale/applyForUser',
    name: 'applyForUser',
    meta: {
      title_en: 'Can Apply Aftersale Order List',
      title: '代用户申请售后'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterApplyForUserList.vue')
  },
  {
    path: '/KiliMall/afterSale/applyForUserForm',
    name: 'applyForUserForm',
    meta: {
      title_en: 'Can Apply Aftersale Order Form',
      title: '代用户申请售后'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterApplyForm.vue')
  },
  {
    path: '/KiliMall/afterSale/afterRefundList',
    name: 'afterRefundList',
    meta: {
      title_en: 'Aftersale Refund Order List',
      title: '售后退款列表'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterRefundList.vue')
  },
  {
    path: '/KiliMall/admin/afterSale/afterReasonGroup',
    name: 'afterReasonGroup',
    meta: {
      title_en: 'Aftersale Reason Group Management',
      title: '售后原因组设置'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterSaleReasonGroup.vue')
  },
  {
    path: '/KiliMall/admin/afterSale/afterReasonSet',
    name: 'afterReasonSet',
    meta: {
      title_en: 'Aftersale Reason Management',
      title: '售后原因设置'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterReasonSet.vue')
  },
  {
    path: '/KiliMall/afterSale/refundDetail',
    name: 'refundDetail',
    meta: {
      title_en: 'Refund Details',
      title: '售后退回详情'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterReturnDetail.vue')
  },
  { path: '/KiliMall/admin/afterSale/afterReasonBind', name: '售后原因分组绑定', component: () => import('@/views/Kilimall/manage/afterSale/afterReason/afterReasonsBind.vue') },
  { path: '/KiliMall/admin/afterSale/afterReasons', name: '售后原因', component: () => import('@/views/Kilimall/manage/afterSale/afterSaleReasonTabs.vue') },
  { path: '/KiliMall/billManage/commission', name: '平台结算单', component: () => import('@/views/Kilimall/manage/billManage/commission.vue') },
  { path: '/lite/admin/restockPlanning/platformRestock', name: '平台备货邀请计划', component: () => import('@/views/Kilimall/manage/restockPlanning/restockPlanPlatform.vue') },
  { path: '/lite/admin/restockPlanning/addRestockPlan', name: '创建备货邀请计划', component: () => import('@/views/Kilimall/manage/restockPlanning/addRestockPlanPlatform.vue') },
  { path: '/lite/admin/restockPlanning/invitedRestock', name: '已邀请备货邀请计划详情', component: () => import('@/views/Kilimall/manage/restockPlanning/invitedRestockPlatform.vue') },
  { path: '/lite/admin/restockPlanning/viewRestock', name: '备货邀请计划查阅页面', component: () => import('@/views/Kilimall/manage/restockPlanning/viewRestockPlatform.vue') },
  { path: '/lite/restockPlanning/restockPlanning', name: 'lite备货邀请', component: () => import('@/views/Kilimall/manage/restockPlanning/restockPlanning.vue') },
  { path: '/lite/restockPlanning/restockDetail/:id', name: 'lite备货邀请详情', component: () => import('@/views/Kilimall/manage/restockPlanning/restockDetail.vue') },
  { path: '/lite/restockPlanning/applyRestock/:id', name: 'lite申请备货', component: () => import('@/views/Kilimall/manage/restockPlanning/applyRestock.vue') },
  {
    path: '/lite/afterSale/list',
    name: 'lite商家售后列表',
    meta: {
      title_en: 'AfterSale Order List',
      title: 'lite商家售后列表'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterList.vue')
  },
  {
    path: '/lite/afterSale/afterDetail',
    name: 'lite商家售后详情',
    meta: {
      title_en: 'AfterSale Order Details',
      title: 'lite商家售后详情'
    },
    component: () => import('@/views/Kilimall/manage/afterSale/afterDetail.vue')
  },
  {
    path: '/lite/shipAddress',
    name: 'lite售后发货地址',
    meta: {
      title_en: 'Shipping Address',
      title: 'lite售后发货地址'
    },
    component: () => import('@/views/Kilimall/seller/StoreAddress/index.vue')
  },
  {
    path: '/lite/shippingAddress',
    name: 'lite售后收货地址',
    meta: {
      title_en: 'Return Address',
      title: 'lite售后收货地址'
    },
    component: () => import('@/views/Kilimall/seller/StoreAddress/index.vue')
  },
  ...constantModules
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})
menuRouter().then((res: any) => {
  res.forEach((e: any) => {
    router.addRoute('layout', e)
  });
})

router.beforeEach((route: any, from, next) => {
  sessionStorage.setItem('isLite', route.path.includes('lite'))
  window.scrollTo(0, 0)
  if (route.path === '/iframe' && route.query.tcn && route.query.ten) {
    let title = decodeURIComponent(route.query.tcn)
    let title_en = decodeURIComponent(route.query.ten)
    let meta = {
      title: title,
      title_en: title_en
    }
    route.meta = meta
  }
  if (route.query.site) {
    localStorage.setItem('code', route.query.site)
    store.dispatch('setSiteCode', route.query.site)
  }
  let storeInfo: any = JSON.parse(localStorage.getItem('StoreInfo'))
  let mandatoryInfo = {
    path: '/KiliMall/shippingAddress',
    title: t('storeAddress.setDefaultAddress'),
  }
  const whitePath = whiteList.some(path => path === route.path)
  const whiteRouteName = whiteNames.some(name => name === route.name)
  // 是否属于登录白名单route
  if (whitePath || whiteRouteName) {
    return next()
  }
  // next()
  // 商家必填信息发货默认地址是否填写校验
  if ((storeInfo && !storeInfo.default_address)) {
    if (route.path == mandatoryInfo.path || route.path == '/home') {
      next()
    } else {
      ElMessageBox.alert(mandatoryInfo.title, 'Hint', {
        confirmButtonText: 'OK',
        callback: (action: Action) => {
          next({ path: mandatoryInfo.path })
        },
        showClose: false
      })
    }
  } else {
    next()
  }

})



export default router
